var Backbone = require('backbone')
  , _ = require('underscore')
  , urlUtils = require('@173js/url')
  , handleLinkClicked = require('./mixins/handleLinkClicked')

module.exports = Backbone.View.extend({
  initialize: function() {
    this.listenTo(this.model, 'changeRoute', this.handleRouteChanged, this)
  }
, events: {
    // 'click a[href!="#"]': 'handleLinkClicked'
  }
, handleLinkClicked: handleLinkClicked
, handleRouteChanged: function() {
    var relativeUrl = urlUtils.getRelativeUrl(
      window.location.href, window.location.origin
    )

    this.$el.css({
      'opacity': 0.5
    , 'pointer-events': 'none'
    })

    this.model.fetchList({ url: relativeUrl })
      .done(_.bind(function(resp) {
        this.$el.html(resp.html)
      }, this))
      .fail(function() { alert('网络出现了问题') })
      .always(_.bind(function() {
        this.$el.css({
          'opacity': 1
        , 'pointer-events': 'auto'
        })
      }, this))
  }
})
